<template>
  <div class="zcxy">
    <div class="clearfix table-tools">
      <div class="buttons">
        <a-form layout='inline'>
          <a-form-item v-if="canSave">
            <a-button icon="plus" type="primary" @click="showEditModal()">楼宇</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="search">
        <a-form layout='inline'>
          <a-form-item @submit="searchList">
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>楼宇名称</span>
              </template>
              <a-input allowClear v-model.trim="searchData.park_name" placeholder="楼宇名称" style="width: 160px"/>
            </a-tooltip>
          </a-form-item>
          <a-form-item @submit="searchList">
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>楼宇地址</span>
              </template>
              <a-input allowClear v-model.trim="searchData.park_address" placeholder="楼宇地址" style="width: 160px"/>
            </a-tooltip>
          </a-form-item>
          <a-form-item v-if="canIndex">
            <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="table">
      <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
      <a-table size="middle" :pagination="false" :bordered='false' rowKey="qrcode_id"
        :columns="columns" :dataSource="list">
          <template slot="index" slot-scope="text, record , index">
            <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
          </template>
          <template slot="image" slot-scope="text, record">
            <LImg :src="text" style="width: 44px; height: 44px; margin: 0 5px 5px 0"/>
          </template>
          <template slot="status" slot-scope="text,record">
            <a-switch checkedChildren="开" unCheckedChildren="关" :checked="text === 1" @change="changeStatus(record)"/>
          </template>
          <template slot="action" slot-scope="text,record">
            <a-icon key="edit" type="edit" @click="showEditModal(record)" />
          </template>
      </a-table>
    </div>
    <div class="page">
      <a-pagination
        :pageSizeOptions="pageSizeOptions"
        :total="pageParams.totalCount"
        showSizeChanger
        :pageSize="pageParams.perPage"
        v-model="current"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
      >
          <template slot='buildOptionText' slot-scope='props'>
            <span v-if="props.value!=='100'">{{props.value}}条/页</span>
            <span v-if="props.value==='100'">100条/页</span>
          </template>
        </a-pagination>
    </div>
    <editModal v-if="editVisible" :item="modalData"/>
    <qrcodeModal v-if='isQrcodeModal' :item='modalData' />
    <copyModal v-if="isCopyModal" :item="modalData"/>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'55px', scopedSlots: { customRender: 'index' }, key: 'index'},
  { title: '楼宇名称', dataIndex: 'park_name', key: '1' },
  { title: '楼宇地址', dataIndex: 'park_address', key: '2' },
  { title: '操作账户', dataIndex: 'park_created_by', key: '3' },
  { title: '操作时间', dataIndex: 'park_created_at', key: '4' },
  { title: '操作', key: 'operation',align:'right', width: 150, scopedSlots: { customRender: 'action' }},
]
								
import C_ITEMS from '@/utils/items'
import editModal from './editModal'
import authority from '@/common/mixins/authority'
import tableMixins from '@/common/mixins/table'
import copyModal from '@/views/market/weipages/zxbb/copyModal'
export default {
  name: 'gjjl',
  provide() {
    return {
      parent: this
    }
  },

  components: {
    editModal,
    copyModal,
  },

  data() {
    return {
      loading: false,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      columns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      current: 1,

      fixedStatus: C_ITEMS.fixedStatus,
      studios: [],

      searchData: {},
      isImg:1,
      visible: false,
      modalData: {},
      editVisible: false,
      isCopyModal: false,
      isQrcodeModal: false,
      authType:['market','qrcodepayment'],
    }
  },
  mixins: [ authority, tableMixins ],
  created() {
    this.getStudio()
  },

  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    closeSearch() {
      this.visible = false
    },
    async getStudio() {
      let res = await this.$store.dispatch('searchBelongStudioAction', {})
      this.studios = res.data
    },
    showEditModal(item) {
      this.modalData = item
      this.editVisible = true
    },
    hideEditModal(type) {
      if (type === 1) {
        this.getList()
      }
      this.editVisible = false
    },
    async getList() {
      if(!this.canIndex){
          this.$message.warning('您暂无权限!!')
          return false
      }
      this.loading = true
      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          if (k === 'created_date') {
            obj['start_date'] = searchData[k][0]
            obj['end_date'] = searchData[k][1]
          } else {
            obj[k] = searchData[k]
          }
        }
      }
      this.searchParams.search = obj
      let res = await this.$store.dispatch('marketingParklistAction', { data: this.searchParams })
      this.list = res.items
      this.pageParams = res._meta
      this.loading = false
    },
    showEditModal(item) {
      this.modalData = item
      this.editVisible = true
    },
    hideEditModal(type) {
      if (type === 1) {
        this.getList()
      }
      this.editVisible = false
    },
    showCopyModal(item){
        this.modalData = item
        this.isCopyModal = true
    },
    hideCopyModal(){
        this.isCopyModal = false
    },
    changeStatus(record) {
      if (record.status === 1) {
        this.deleteItem(record)
      } else {
        this.recoveryItem(record)
      }
    },
    deleteItem(item) { 
      let that = this
      return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('marketingQrcodepaymentDeleteAction', { data: { qrcode_id: item.qrcode_id } })
            if (res) {
              item.status = 0
              resolve(res)
              this.$message.success('操作成功!')
            }
          }).catch(error => console.log(error))
    },
    recoveryItem(item) {
      let that = this
      return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('marketingQrcodepaymentRecoveryAction', { data: { qrcode_id: item.qrcode_id  } })
            if (res) {
              item.status = 1
              resolve(res)
              this.$message.success('操作成功!')
            }
          }).catch(error => console.log(error));
    },
    creatQRcode(val){
        this.modalData = val
        this.isQrcodeModal = true
    },
    hideQrcodeModal(){
        this.isQrcodeModal = false
    }
  }
}
</script>
